import React from 'react';

/**
 * Icons.
 */
import ArrowMessageHorizontal from 'assets/icons/arrow-message-horizontal.png';
import ArrowMessageSuccessHorizontal from 'assets/icons/arrow-message-success-horizontal.png';
import ArrowDonationHorizontal from 'assets/icons/arrow-donation-horizontal.png';

/**
 * Style.
 */
import './landing-step-arrow.scss';

const stepIcon = {
  1: ArrowMessageHorizontal,
  2: ArrowMessageSuccessHorizontal,
  3: ArrowDonationHorizontal,
};

const LandingStepArrow = ({ step }) => (
  <div className="landing-step-arrow-wrapper">
    <img src={stepIcon[step]} alt="" />
  </div>
);

export default LandingStepArrow;
